import React from 'react';
import { Age, Code } from './LivePage';
import PagedWorkloadPage from './PagedWorkloadPage';

/**
 * Limit Ranges.
 *
 * Previously showed a fabricated "default-limit-range, 100m–2 CPU, 128Mi–…" on every cluster.
 * dev45 has none, so the page was inventing a constraint that did not exist. Now live.
 */
const range = (min, max) => (min || max) ? `${min || '—'} – ${max || '—'}` : '—';

export default function LimitRanges() {
  return (
    <PagedWorkloadPage
      title="Limit Ranges" kind="LimitRange" resource="limitranges"
      label="limit ranges" detail={false}
      cols={['Name', 'Namespace', 'Type', 'CPU (min–max)', 'Memory (min–max)', 'Default CPU/Mem', 'Age']}
      renderRow={l => [
        <td key="n"><Code>{l.name}</Code></td>,
        <td key="ns" style={{ color: 'var(--ink-2)', fontSize: 13 }}>{l.namespace}</td>,
        <td key="t">
          {l.type || '—'}
          {/* A LimitRange can hold several entries (Container, Pod, PVC); the row shows the
              first, so say when more exist rather than hiding them. */}
          {l.entry_count > 1 && (
            <span style={{ fontSize: 11, color: 'var(--muted-2)' }}> +{l.entry_count - 1} more</span>
          )}
        </td>,
        <td key="c" style={{ fontSize: 12 }}>{range(l.min_cpu, l.max_cpu)}</td>,
        <td key="m" style={{ fontSize: 12 }}>{range(l.min_memory, l.max_memory)}</td>,
        <td key="d" style={{ fontSize: 12, color: 'var(--muted)' }}>
          {l.default_cpu || l.default_memory
            ? `${l.default_cpu || '—'} / ${l.default_memory || '—'}` : '—'}
        </td>,
        <td key="a"><Age ts={l.created_at} /></td>,
      ]}
    />
  );
}
